export default function About() {
  return (
    <section id="about" className="bg-white py-32">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex gap-20">
          {/* Left Column */}
          <div className="w-[45%]">
            <p className="text-xs uppercase tracking-widest text-[#6B5B95] mb-6">WHO WE ARE</p>
            <p className="text-3xl text-[#1A1A1A] leading-relaxed font-serif">
              We are a dedicated team of iOS experts specializing in developing cutting-edge mobile applications that prioritize security, performance, and exceptional user experience.
            </p>
          </div>

          {/* Right Column */}
          <div className="w-[55%]">
            <div className="relative bg-gradient-to-br from-white to-[#F8FAFF] rounded-[32px] p-12 shadow-xl">
              <div className="absolute top-8 left-8 bg-[#E8F5E9] text-[#2E7D32] text-xs uppercase tracking-wide px-4 py-2 rounded-full">
                VPN PRODUCT
              </div>
              <div className="mt-12">
                <img 
                  src="https://public.readdy.ai/ai/img_res/d4a5fb027a4f9481bb4c48178b81c212.jpg" 
                  alt="VPN Product Interface" 
                  title="SecureVPN iOS Application"
                  className="w-full h-auto object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}